type Props = {
  height: string;
  stroke?: string;
  width: string;
};
const StarHalf = ({ height, width, stroke = '#A9A9A9' }: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M8 2.12978L9.60888 5.38972L9.72521 5.62544L9.98535 5.66324L13.5829 6.186L10.9797 8.72352L10.7915 8.907L10.8359 9.16608L11.4504 12.7491L8.23267 11.0574L8 10.9351L7.76733 11.0574L4.54957 12.7491L5.16411 9.16608L5.20854 8.907L5.02031 8.72352L2.41708 6.186L6.01465 5.66324L6.27478 5.62544L6.39112 5.38972L8 2.12978Z"
        stroke={stroke}
      />
    </svg>
  );
};

export default StarHalf;
